import { Component, inject, ChangeDetectionStrategy, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { FanCurvePerformanceEntry } from '../../../model/ratings/fan-curve-performance-entry';
import { AhyOperatingPoint } from '../../../model/ahy-operating-point';

@Component({
  selector: 'app-air-handler-unit-fan-performance-summary',
  imports: [MatIcon],
  templateUrl: './air-handler-unit-fan-performance-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './air-handler-unit-fan-performance-summary.component.css',
})
export class AirHandlerUnitFanPerformanceSummaryComponent {
  private userStateService = inject(UserStateService);
  private sectionKey = ConfigurationSection.FAN_PERFORMANCE_SUMMARY;
  readonly performanceSummary = input<FanCurvePerformanceEntry[]>([]);
  readonly operatingPoint = input.required<AhyOperatingPoint>();
  isExpanded = true;

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isOperatingPoint(entry: FanCurvePerformanceEntry): boolean {
    if (this.operatingPoint()) {
      return this.operatingPoint().airflow === entry.Airflow;
    }
    return false;
  }
}
